import React from 'react';
import firebase from 'firebase/app';
import "firebase/database";

export default class NewMessageForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            body: '',
        }
    }

    handleSubmit(evt) {
        evt.preventDefault();
        let user = this.props.user;
        let message = {
            body: this.state.body,
            author: {
                displayName: user.displayName,
                photoURL: user.photoURL,
                uid: user.uid,
            },
            createdAt: firebase.database.ServerValue.TIMESTAMP,
        };
        this.props.messagesRef.push(message)
            .then(() => this.setState({ body: '', fbError: undefined }))
            .catch(err => this.setState({ fbError: err }));;
    }

    render() {
        return (
            <form onSubmit={evt => this.handleSubmit(evt)}>
                <div className="input-group">
                    <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">+</span>
                    </div>
                    <input type="text"
                        className="form-control"
                        placeholder={`Message #${this.props.chanName}`}
                        value={this.state.body}
                        aria-label="Message"
                        aria-describedby="basic-addon1"
                        onInput={evt => this.setState({ body: evt.target.value })}
                    />
                </div>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/NewMessageForm.js